export default __webpack_public_path__ + "static/media/referencePointOff.d1aa2852.svg";